import React, {Component} from 'react'
import SearchItemHeader from "./SearchItemHeader"
import {getBarcodeByNumber} from "../../../services/api/apiBarcode"
import ItemDetails from "./ItemDetails"


class ItemDetailPage extends Component {
    state = {
        item_number: null,
        item_index: null,
        loading: false,
        error: '',
        item: null,
    }

    componentDidMount() {
        const {item} = this.props

        if(item) this._handleSubmit(item)
    }

    _parseBarcode = (barcode) => {
        const vBarcode = barcode.trim().replace(/#/gi, '')
        if (!vBarcode) return false

        if (!vBarcode.includes('_')) {
            const vNumber = parseInt(vBarcode, 10)
            if (!vBarcode || vBarcode < 0) return false

            return {
                item_number: vNumber,
                item_index: 1,
            }
        }

        const arr = vBarcode.split('_')
        if (!arr || arr.length !== 2) return false

        const [item_number, item_index] = arr
        const vItemNumber = parseInt(item_number, 10)
        const vItemIndex = parseInt(item_index, 10)

        return {
            item_number: vItemNumber,
            item_index: vItemIndex,
        }
    }

    _handleSubmit = async (barcode) => {
        console.log('Submit barcode:', barcode)
        const complex = this._parseBarcode(barcode)
        if (!complex) {
            return window.alert('Barcode is invalid')
        }

        const {item_number, item_index} = complex

        this.setState({
            item_number,
            item_index,
        }, () => {
            return this._searchBarcode()
        })
    }

    _parseItemData = (data, item_index) => {
        if (!data || typeof data !== 'object') {
            throw new Error('Something went wrong.')
        }

        const {products, ...rest} = data
        const totalItems = products ? products.length : 0

        const product = products.find(_product => _product && _product.pos === item_index)
        if (!product) {
            throw new Error('Product item not found.')
        }

        const {_id: productId} = product

        delete rest.items

        return {
            ...rest,
            productId,
            product,
            totalItems,
        }
    }

    _searchBarcode = async () => {
        if (this.state.loading) return false

        this.setState({
            error: '',
            loading: true,
        })

        try {
            const {item_number, item_index} = this.state
            const {data: response} = await getBarcodeByNumber(item_number, `item=${item_index}`)

            const {success, data, message} = response

            if (!success) {
                throw new Error(message)
            }

            const item = this._parseItemData(data, item_index)

            this.setState({
                loading: false,
                item,
                error: '',
            })
        } catch (e) {
            return this.setState({
                loading: false,
                error: e.message || e,
            })
        }
    }

    render() {
        const {loading, item, error} = this.state

        return (
            <div className="ItemDetailPage">
                <SearchItemHeader loading={loading} onSubmit={this._handleSubmit} {...this.props}/>
                {
                    !!error &&
                    <div className="Error mt-3">
                        <div className="alert alert-danger">{error}</div>
                    </div>
                }
                {
                    !!item &&
                    <ItemDetails item={item}/>
                }
            </div>
        )
    }
}

export default ItemDetailPage
